import React from 'react'

export default function BuyDocumentation({documentationData,formatKeyName}) {
  return (
     <div className="PropertyDocumentation property-details-block">
                <div className="row">
                  <div className="col-12">
                    <div className="property-documentation-detail">
                      <h3> Documentation</h3>
                      <div className="documentation-included">
                        <span className="Documentation-sub-heading">Included :</span>
                       
                        <ul className="property-documentation-grid">
                         
                          {Object.entries(documentationData||{}).map(([key,value])=> value===true && (
                                <li key={key}>
                            <svg
                              width="20"
                              height="18"
                              viewBox="0 0 20 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_774_399)">
                                <path
                                  d="M17.1429 17.6401H0V0.360107H13.1429V2.08811H1.71429V15.9121H16V9.57611H17.7143V17.6401H17.1429ZM3.2 8.69771L4.49071 7.39667L8.36357 11.3005L18.135 1.45091L19.4286 2.74907L8.36357 13.9026L3.2 8.69771Z"
                                  fill="#FF3155"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_774_399">
                                  <rect width="20" height="18" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>{" "}
                            {formatKeyName(key)}
                          </li>
                          ))}
                        
                        </ul>
                      </div>
                      <div className="documentation-not-included">
                        <span className="Documentation-sub-heading">Not Included :</span>
                        <ul className="property-documentation-grid not-incluced">

                          {Object.entries(documentationData||{}).map(([key,value])=> value===false && (
                              <li>
                            {" "}
 <svg
      width={17}
      height={17}
      viewBox="0 0 304.223 304.223"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill="#333333"
          d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109
          c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.982,0,152.112,0z
          M152.112,275.989
          c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891
          s123.891,55.565,123.891,123.891
          C276.003,220.424,220.432,275.989,152.112,275.989z"
        />
        <path
          fill={"#333333"}
          d="M226.92,138.261H77.308
          c-7.658,0-13.853,6.206-13.853,13.853
          c0,7.664,6.201,13.853,13.853,13.853
          H226.92
          c7.658,0,13.859-6.19,13.859-13.853
          C240.779,144.467,234.573,138.261,226.92,138.261z"
        />
      </g>
    </svg>



                           {" "}
                            {formatKeyName(key)}
                          </li>
                          ))}
                        
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  )
}
